export interface LiveTestimonial {
  tweetId: string;
  text: string;
  authorName: string;
  authorUsername: string;
  avatarUrl: string;
  createdAt: string;
  tweetUrl: string;
  mediaUrl: string;
  highlight: string;
  likeCount: number;
}

export interface LiveTestimonialsFeed {
  testimonials: LiveTestimonial[];
  syncedAt: string;
  source: "x" | "fallback";
}

export function rankLiveTestimonials(
  testimonials: LiveTestimonial[],
): LiveTestimonial[] {
  return [...testimonials].sort(
    (left, right) =>
      Number(Boolean(right.highlight)) - Number(Boolean(left.highlight)) ||
      right.likeCount - left.likeCount ||
      right.createdAt.localeCompare(left.createdAt) ||
      right.tweetId.localeCompare(left.tweetId),
  );
}

export const LIVE_TESTIMONIALS_FALLBACK: LiveTestimonialsFeed = {
  syncedAt: "2026-07-13T17:45:54.000Z",
  source: "fallback",
  testimonials: [
    {
      tweetId: "2076473539075686459",
      text: "Cash both @SleeperPicksHQ discounts! @UpsideTools whale watch is 100% goated 🙌🏽 anyone able to lock these in with me?",
      authorName: "BG",
      authorUsername: "BG__bets",
      avatarUrl: "https://pbs.twimg.com/profile_images/1956035382740705284/x41WZuli_200x200.jpg",
      createdAt: "2026-07-13T01:07:25.000Z",
      tweetUrl: "https://x.com/BG__bets/status/2076473539075686459",
      mediaUrl: "https://pbs.twimg.com/media/HNEdrcGasAAgwN6.jpg",
      highlight: "",
      likeCount: 6,
    },
    {
      tweetId: "2076453037023891600",
      text: "Just here to show it cashed even though nobody copied. @UpsideTools has been showing great value on Dabble lately.",
      authorName: "Swamp",
      authorUsername: "brady_swampy14",
      avatarUrl: "https://pbs.twimg.com/profile_images/955281413485494272/DfPLql_9_200x200.jpg",
      createdAt: "2026-07-12T23:45:57.000Z",
      tweetUrl: "https://x.com/brady_swampy14/status/2076453037023891600",
      mediaUrl: "https://pbs.twimg.com/media/HNELB7ZXgAAt5lL.jpg",
      highlight: "",
      likeCount: 5,
    },
    {
      tweetId: "2076421462639231339",
      text: "BANG! Early games came through. Shoutout @UpsideTools as always for the late-night value 🙏",
      authorName: "DT",
      authorUsername: "daviddailydfs_",
      avatarUrl: "https://pbs.twimg.com/profile_images/2043725969115197440/Nxv-LYJc_200x200.jpg",
      createdAt: "2026-07-12T21:40:29.000Z",
      tweetUrl: "https://x.com/daviddailydfs_/status/2076421462639231339",
      mediaUrl: "https://pbs.twimg.com/media/HNDuUR2bgAEN3Vl.jpg",
      highlight: "",
      likeCount: 5,
    },
    {
      tweetId: "2076300519522320889",
      text: "Cash this for a 4.30x ✅ S/o to @UpsideTools on the sharp read.",
      authorName: "DoubleBB",
      authorUsername: "DooubleBB",
      avatarUrl: "https://pbs.twimg.com/profile_images/2070906337370775552/9T-Izi-n_200x200.jpg",
      createdAt: "2026-07-12T13:39:54.000Z",
      tweetUrl: "https://x.com/DooubleBB/status/2076300519522320889",
      mediaUrl: "https://pbs.twimg.com/media/HNCAUc8XIAAigjE.jpg",
      highlight: "4.30x",
      likeCount: 2,
    },
    {
      tweetId: "2075050047129919888",
      text: "Two Betr cashes from the stream: 7.5x and 6x. Kinda in love with @UpsideTools 💰",
      authorName: "Icon",
      authorUsername: "IconBetsVIP",
      avatarUrl: "https://pbs.twimg.com/profile_images/2046957135750201344/-qnYeoL6_200x200.jpg",
      createdAt: "2026-07-09T02:50:58.000Z",
      tweetUrl: "https://x.com/IconBetsVIP/status/2075050047129919888",
      mediaUrl: "https://pbs.twimg.com/media/HMwPBWWW8AAJJht.jpg",
      highlight: "7.5x BETR",
      likeCount: 12,
    },
    {
      tweetId: "2074700891068755975",
      text: "This isn't a brag post. It's proof: $940 in the last 7 days. Same $10 bets I've always made. @UpsideTools",
      authorName: "EJ",
      authorUsername: "EarlyJuice__",
      avatarUrl: "https://pbs.twimg.com/profile_images/2068814807923367936/iN9WTDz1_200x200.jpg",
      createdAt: "2026-07-08T03:43:33.000Z",
      tweetUrl: "https://x.com/EarlyJuice__/status/2074700891068755975",
      mediaUrl: "https://pbs.twimg.com/media/HMrQOUuXoAAAe2y.jpg",
      highlight: "$940",
      likeCount: 20,
    },
    {
      tweetId: "2074683297435660612",
      text: "Cash the 25X on PrizePicks. The new +EV Sniper on @UpsideTools is so goated.",
      authorName: "Matt Downs",
      authorUsername: "PlusEV",
      avatarUrl: "https://pbs.twimg.com/profile_images/2006916677863186432/TfDPmEwN_200x200.jpg",
      createdAt: "2026-07-08T02:33:38.000Z",
      tweetUrl: "https://x.com/PlusEV/status/2074683297435660612",
      mediaUrl: "https://pbs.twimg.com/media/HMrBdsxX0AARp29.jpg",
      highlight: "25X",
      likeCount: 83,
    },
    {
      tweetId: "2074330185059770385",
      text: "Back from Hawaii and we hit those 🤑 18.5x secured from @UpsideTools.",
      authorName: "BG",
      authorUsername: "BG__bets",
      avatarUrl: "https://pbs.twimg.com/profile_images/1956035382740705284/x41WZuli_200x200.jpg",
      createdAt: "2026-07-07T03:10:29.000Z",
      tweetUrl: "https://x.com/BG__bets/status/2074330185059770385",
      mediaUrl: "https://pbs.twimg.com/media/HMmAT2paUAA9GBy.jpg",
      highlight: "18.5x",
      likeCount: 24,
    },
  ],
};
